const AFFILIATE_SOURCE = 'Rewardful'
const AFFILIATE_MEDIUM = 'Affiliate'

export default {
  computed: {
    isRewardfulExist () {
      return !!(window.Rewardful && window.Rewardful.referral)
    },

    rewardfulAffiliate () {
      if (!this.isRewardfulExist) return null

      return window.Rewardful.affiliate
    },

    getAffiliateData () {
      return {
        utm_source: AFFILIATE_SOURCE,
        utm_medium: AFFILIATE_MEDIUM,
        utm_campaign: this.rewardfulAffiliate.token
      }
    }
  },

  methods: {
    insertRewardfulCode () {
      const a = document.getElementsByTagName('head')[0]

      const rewardfulScript = document.createElement('script')
      rewardfulScript.type = 'text/javascript'

      const code = '(function(w,r){w._rwq=r;w[r]=w[r]||function(){(w[r].q=w[r].q||[]).push(arguments)}})(window,\'rewardful\');'

      try {
        rewardfulScript.appendChild(document.createTextNode(code))
        a.appendChild(rewardfulScript)
      } catch (e) {
        rewardfulScript.text = code
        a.appendChild(rewardfulScript)
      }
    },

    insertRewardful () {
      const a = document.getElementsByTagName('head')[0]
      const r = document.createElement('script')

      r.async = true
      r.src = 'https://r.wdfl.co/rw.js'
      r.setAttribute('data-rewardful', process.env.VUE_APP_REWARDFUL_ID)
      a.appendChild(r)
    }
  }
}
